import Tooltip from '@material-ui/core/Tooltip'
import styled from 'styled-components'

export const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip classes={{ popper: className, tooltip: 'tooltip' }} {...props} />
))`
  & .tooltip {
    background-color: ${({ theme }) => theme.palette.secondary.contrastText};
    color: ${({ theme }) => theme.palette.secondary.dark};
    box-shadow: ${({ theme }) => theme.shadows[5]};
    padding: 16px;
  }
  & [class*='MuiTooltip-arrow'] {
    color: ${({ theme }) => theme.palette.secondary.contrastText};

    ::before {
      border: 1px solid rgb(206 207 209 / 50%);
    }
  }
`
